import React from "react";
import {
  HomeOutlined,
  FolderOpenFilled,
  LineChartOutlined,
  BarChartOutlined,
  QuestionCircleOutlined,
  DownloadOutlined,
  BlockOutlined,
  UserOutlined,
} from "@ant-design/icons";

export const SidemenuData = [
  {
    titleKey: "menu.home",
    icon: <HomeOutlined />,
    link: "/",
    public: true,
  },
  {
    titleKey: "menu.storage",
    icon: <FolderOpenFilled />,
    link: "/storage/",
  },
  {
    titleKey: "menu.charts",
    icon: <LineChartOutlined />,
    link: "/charts/",
  },
  {
    titleKey: "menu.analysis",
    icon: <BarChartOutlined />,
    link: "/analysis",
  },
  {
    titleKey: "menu.guide",
    icon: <QuestionCircleOutlined />,
    link: "/usersManual/",
  },
  {
    titleKey: "menu.download",
    icon: <DownloadOutlined />,
    link: "/Download/",
    public: true,
  },
  {
    titleKey: "menu.gallery",
    icon: <BlockOutlined />,
    link: "/BoundingBox/",
  },
  {
    titleKey: "menu.profile",
    icon: <UserOutlined />,
    link: "/profile",
    public: true,
  },
];